// extracted by mini-css-extract-plugin
module.exports = {"HomeBlog":"HomeBlog_HomeBlog__3LKII","textContent":"HomeBlog_textContent__3ivxP"};